import palette from '../../palette';
import Color from 'color';

export default {
  root: {
    "& .MuiSvgIcon-root": {
      ['@media (max-width: 768px)']: {
        height: "15px",
        width: "15px"
      }
    }
  },
  colorSecondary: {
    "&$checked": {
      color: palette.bronze,
      "&:hover": {
        backgroundColor: Color(palette.bronze).alpha(0.2).string()
      }
    },
    "&:hover": {
      backgroundColor: Color(palette.bronze).alpha(0.2).string()
    }
  },
};